// openEHR RM model — shared internals (not part of the public barrel)
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

// Hand-written implementation based on BMM schema: rm v1.2.0
// BMM Version: 2.4
// Schema Revision: 1.2.0.2
// Description: openEHR Reference Model
// Source: https://raw.githubusercontent.com/openEHR/specifications-RM/master/computable/BMM/openehr_rm_1.2.0.bmm.json
// Last synced with BMM: 2026-09-16
//
// ✅ ENHANCED IMPLEMENTATION
// This file contains fully implemented methods and additional functionality beyond the BMM specification.
// It is safe to edit this file - your changes will not be overwritten by the generator.
//
// The generator outputs to /generated directory. To update this file for a new BMM version:
// 1. Run generator to update /generated/openehr_rm.ts
// 2. Compare changes using: deno run --allow-read tasks/compare_bmm_versions.ts
// 3. Manually merge relevant changes into this file
//
// For more information about openEHR specifications, visit: https://specifications.openehr.org/

import * as openehr_base from "../base/mod.ts";

// Unknown types - defined as 'any' for now
export type T = any;

/** Numeric part of `accuracy` when stored as BASE Real/Integer wrappers (BMM types it as Any). */
export function accuracyAsNumber(acc: openehr_base.Any | undefined): number | undefined {
  if (acc === undefined) return undefined;
  if (acc instanceof openehr_base.Real) return acc.value;
  if (acc instanceof openehr_base.Integer) return acc.value;
  if (acc instanceof openehr_base.Integer64) return acc.value;
  if (acc instanceof openehr_base.Double) return acc.value;
  return undefined;
}
